module.exports = __webpack_public_path__ + "static/media/arena-map.b37ee5b5.png";